import React from 'react';
import {connect} from 'react-redux';
import './ViewUser.scss';
import PropTypes from 'prop-types';
import {useHistory} from 'react-router-dom';
import NavBefore from '../../../common/components/NavBefore/NavBefore';

/**
 * @description
 * @param { object } props no redux
 * @return { * } component
 */
const ViewUser = (props) => {
    const {
        title,
        providerSelected,
        showSidebar,
    } = props;

    const history = useHistory();

    return (
        <div className={showSidebar && window.innerWidth <= 700 ? 'ul-div-background bg-mt-10' : 'ul-div-background'}>
            <p className="ul-p-name">{providerSelected?.user?.email}</p>
            <div className="ul-div-section">
                <div className="ul-div-sect-header vu-header">
                    <NavBefore event={()=>history.goBack()}/>
                    <div>
                        <p className="ul-p-title">{title.toUpperCase()}</p>
                        <hr id="id-hr"/>
                    </div>
                </div>

                <div className="ul-div-form vu-content">
                    <div className="vu-title">
                        <text className="vu-name">{providerSelected?.name}</text>
                        <button className="btn-close" onClick={()=>history.goBack()}>X</button>
                    </div>
                    <form className="vu-form">
                        <div className="vu-fm">
                            <div className="vu-div-container">
                                <div className="vu-row-data">
                                    <text>CUIT: </text>
                                    <text>{providerSelected.cuitOrCuil}</text>
                                </div>
                                <div className="vu-row-data">
                                    <text>E-mail: </text>
                                    <text>{providerSelected.user?.email}</text>
                                </div>
                                <div className="vu-row-data">
                                    <text>Teléfonos</text>
                                    <ul>
                                        {
                                            providerSelected.phoneNumbers.map(({type, number}, index) => (
                                                <li key={index}>
                                                    {type === 'PERSONAL' ? 'Personal: ' : 'Oficina: ' }{number}
                                                </li>
                                            ))
                                        }
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="vu-fm">
                            <div className="vu-row-data">
                                <text>Prestador: </text>
                                <text title={providerSelected?.salesforceProviderName} >{providerSelected?.salesforceProviderName}</text>
                            </div>
                            <div className="vu-row-data">
                                <text>Sede: </text>
                                <text title={providerSelected?.salesforceBranchName} >
                                    {providerSelected.salesforceBranchName ? providerSelected.salesforceBranchName : '-'}
                                </text>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    name: localStorage.getItem('name'),
    title: state.home.title,
    providerSelected: state.home.providerSelected,
    showSidebar: state.common.showSidebar,
});

const mapDispatchToProps = (dispatch) => ({});

ViewUser.propTypes = {
    name: PropTypes.string,
    title: PropTypes.string,
    providerSelected: PropTypes.object,
};


export default connect(mapStateToProps, mapDispatchToProps)(ViewUser);

